export type PendingSubmission = {
  organizationId: string;
  categoryId: string;
  payload: Record<string, unknown>;
  notes: string;
  clientRequestId: string;
  submissionIntent?: "standard" | "repeat";
  sourceSubmissionId?: string;
  queuedAt: string;
};

function key(orgId: string, suffix: string) {
  return `campPoints:${orgId}:${suffix}`;
}

export function readFavorites(orgId: string): string[] {
  try { return JSON.parse(localStorage.getItem(key(orgId, "favorites")) ?? "[]"); }
  catch { return []; }
}
export function saveFavorites(orgId: string, favorites: string[]) {
  localStorage.setItem(key(orgId, "favorites"), JSON.stringify(favorites));
}
export function readQueue(orgId: string): PendingSubmission[] {
  try { return JSON.parse(localStorage.getItem(key(orgId, "queue")) ?? "[]"); }
  catch { return []; }
}
export function saveQueue(orgId: string, queue: PendingSubmission[]) {
  localStorage.setItem(key(orgId, "queue"), JSON.stringify(queue));
}
